export const SiteColors = {
    black: '#000000',
    white: '#ffffff',
    greyLight: '#f0f0f0',
    greyDark: '#969696',
    green: '#AEB917'
}